export const grouped_units = {
  area_volume: ["m^2", "m^3", "km^2", "ft^2", "ha", "daa", "acre"],
  length: ["m", "km"],
  percentage: ["%"],
  full_time_equivalent: ["FTE"],
  power_energy_electrical: ["kW", "MW", "GW", "kWh", "MWh", "GWh", "TWh", "kV"],
  mass: ["t", "kg", "g"],
} as const;

export function swapUnit(unit: string) {
  return unit.replace(/\^2$/, "²").replace(/\^3$/, "³");
}

const powerOfRegex = /^(.*?)\^([0-9]+)$/;
const superscriptMap: Record<string, string> = {
  "0": "⁰",
  "1": "¹",
  "2": "²",
  "3": "³",
  "4": "⁴",
  "5": "⁵",
  "6": "⁶",
  "7": "⁷",
  "8": "⁸",
  "9": "⁹",
};

export function formatUnit(value: string): string {
  const matches = powerOfRegex.exec(value);

  if (matches) {
    const base = matches[1];
    const exponent = matches[2];

    const superscriptExponent = [...exponent]
      .map((digit) => superscriptMap[digit])
      .join("");

    return `${base}${superscriptExponent}`;
  }

  return value;
}
